import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchHistory,
  setCurrent,
  initViewOnlyQuiz,
  changeState
} from '../actions/index';

import FontIcon from 'material-ui/FontIcon';
import Toggle from 'material-ui/Toggle';
import Collapsible from 'react-collapsible';
import _ from 'lodash';
import { Line } from 'rc-progress';

import Quiz from './Quiz';
import QbankButton from '../components/QbankButton';
import LoadingSpinner from '../components/LoadingSpinner';
import Title from '../components/Title';
import QbankBreak from '../components/QbankBreak';
import { HELPERS, ASSET_PREFIX } from '../config/constants';

import ArrowRight from '../images/arrow-right.svg';
import ArrowLeft from '../images/arrow-left.svg';
import FilterIcon from '../images/filter@3x.png';
import FilterActiveIcon from '../images/filter-active@3x.png';
import '../styles/History.css';

//TODO remove if problematic
const minHeight = window.innerHeight;
const filters = ['Quizzes', 'Bookmarks', 'Notes'];

const isMobile = window.innerWidth < 1023;
const isSmallMobile = window.innerWidth < 500;

const buttonStyle = {
  height: 45,
  width: '100%'
};

const styles = {
  quizButton: isSmallMobile
    ? {
        width: '175px',
        height: '35px',
        fontSize: '12px',
        margin: 'auto'
      }
    : isMobile
      ? {
          width: '220px',
          height: '40px',
          fontSize: '13px',
          margin: 'auto'
        }
      : {
          width: '280px',
          height: '50px',
          fontSize: '15px',
          margin: 0
        }
};

const pageSize = 10;
const pageDisplayCount = 5;
class QuizHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterKey: 'quizzes',
      tagFilter: null,
      quizExpandedMap: {},
      paginationIndex: 0,
      currentPageRange: [],
      incorrectFilter: false,
      reviewFlag: false,
      quizIndex: null,
      mobileFilter: false
    };

    this.buildHistoryCheckInput = this.buildHistoryCheckInput.bind(this);
  }

  componentWillMount() {
    if (this.props.isDirty && !this.props.history.loading) {
      this.props.fetchHistory();
    }
  }

  componentWillReceiveProps(next) {
    console.log(this.props, next);
  }

  buildHistoryCheckInput(label, key, isTag) {
    const { filterKey, tagFilter } = this.state;
    const isChecked = isTag
      ? tagFilter === null
        ? label === 'ALL'
        : label.toLowerCase() ===
          this.props.tags.filter(t => t.id === tagFilter)[0].title.toLowerCase()
      : filterKey.toLowerCase() === label.toLowerCase();

    return (
      <div
        key={key}
        onClick={() =>
          this.setState(
            Object.assign(
              isTag
                ? {
                    tagFilter:
                      label !== 'ALL'
                        ? this.props.tags.filter(t => t.title === label)[0].id
                        : null
                  }
                : { filterKey: label.toLowerCase() },
              {
                paginationIndex: 0,
                currentPageRange: []
              }
            )
          )
        }
        className="history-check-input"
      >
        <FontIcon className="material-icons option-select-icon" color="black">
          {isChecked ? 'check_circle' : 'radio_button_unchecked'}
        </FontIcon>
        <p>{label || 'All'}</p>
      </div>
    );
  }

  quizExpandToggle(id) {
    const quizExpandedMap = Object.assign(this.state.quizExpandedMap, {
      [id]: !this.state.quizExpandedMap[id]
    });
    this.setState({
      quizExpandedMap
    });
  }

  buildQuizCollapsible(quiz, index) {
    const quizDate = new Date(quiz.createdAt);
    const percent = Math.round(
      100 *
        (quiz.correctCount /
          quiz.questions.reduce(
            (count, q) => (q.answered ? count + 1 : count),
            0
          ))
    );

    return (
      <div className="history-quiz" key={quiz.id}>
        <div
          className="history-quiz-info"
          onClick={(e, val) => {
            this.quizExpandToggle(quiz.id);
          }}
        >
          <div className="history-quiz-info-primary">
            <p>
              {quizDate.toLocaleDateString('en-us', {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
              })}
            </p>
            <p>{quiz.questions.length} Questions</p>
            <p>{`${quiz.mode === 0 ? 'Study' : 'Test'}${
              isSmallMobile ? '' : ' Mode'
            }`}</p>
            <p style={{ color: HELPERS.GET_PERCENT_COLOR(percent) }}>
              {percent}%
            </p>
          </div>
          <div className="history-quiz-cta">
            <p
              className="review-cta"
              onClick={e => {
                e.stopPropagation();
                this.reviewQuizOrSelection(index);
              }}
            >{`REVIEW${isSmallMobile ? '' : ' QUIZ'}`}</p>
            <p className="history-expand">
              {this.state.quizExpandedMap[quiz.id] ? '-' : '+'}
            </p>
          </div>
        </div>
        <Collapsible open={this.state.quizExpandedMap[quiz.id]}>
          {quiz.questions.map((q, i) => this.buildListItem(q, i, index))}
        </Collapsible>
      </div>
    );
  }

  buildListItem(item, questionIdx, quizIdx) {
    const answered = item.options[item.selectedOptionIndex];
    const correct =
      answered && item.options[item.selectedOptionIndex].correctOption;
    const itemTag = this.props.tags.filter(
      t => t.id === item.organSystemTagId
    )[0];
    const notes = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-notes@3x.png`)
      : null;
    const bookmark = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-bookmark@3x.png`)
      : null;

    return (
      <div className="history-item" key={item.id}>
        <div className="history-item-start">
          <FontIcon
            className="material-icons option-select-icon history-item-icon"
            color={answered ? (correct ? '#94C057' : '#FF7362') : '#BDBBBB'}
          >
            {answered
              ? correct ? 'check_circle' : 'cancel'
              : 'radio_button_unchecked'}
          </FontIcon>
          <div className="history-icon-wrapper">
            <img src={itemTag ? itemTag.imageUrl : ''} />
          </div>
          <p className="history-item-tag">{itemTag ? itemTag.title : ''}</p>
          <span
            className="history-item-body"
            dangerouslySetInnerHTML={{
              __html: unescape(
                `${item.body.slice(
                  0,
                  item.body.indexOf(
                    ' ',
                    isMobile ? (isSmallMobile ? 50 : 75) : 100
                  )
                )}...`
              )
            }}
          />
        </div>
        <div
          className="history-item-end"
          onClick={() => this.reviewQuizOrSelection(quizIdx, questionIdx)}
        >
          {item.notes ? (
            <img className="history-item-notes" src={notes} />
          ) : null}
          {item.flagged ? <img src={bookmark} /> : null}
          <img src={ArrowRight} />
        </div>
      </div>
    );
  }

  filterListData() {
    const history = this.props.history ? _.cloneDeep(this.props.history) : null;
    const { filterKey, tagFilter, incorrectFilter } = this.state;

    const isIncorrect = q =>
      q.selectedOptionIndex !== null && !q.lastAttemptCorrect;
    const hasTag = q => q.organSystemTagId === tagFilter;
    const hasQuestions = q => q.questions.length > 0;

    if (history) {
      if (tagFilter === null) {
        if (incorrectFilter === false) {
          return history[filterKey] || [];
        } else if (filterKey === 'quizzes') {
          return history.quizzes
            ? history.quizzes
                .map(q => {
                  const questions = q.questions.filter(isIncorrect);
                  return Object.assign(q, { questions, correctCount: 0 });
                })
                .filter(hasQuestions)
            : [];
        }
        return history[filterKey].filter(isIncorrect);
      }
      if (incorrectFilter === false) {
        if (filterKey === 'quizzes') {
          return history.quizzes
            ? history.quizzes
                .map(q => {
                  const questions = q.questions.filter(hasTag);
                  const correctCount = questions.reduce(
                    (num, q) =>
                      q.selectedOptionIndex !== null &&
                      q.options[q.selectedOptionIndex].correctOption
                        ? num + 1
                        : num,
                    0
                  );
                  return Object.assign(q, { questions, correctCount });
                })
                .filter(hasQuestions)
            : [];
        }
        return history[filterKey] ? history[filterKey].filter(hasTag) : [];
      }
      if (filterKey === 'quizzes') {
        return history.quizzes
          ? history.quizzes
              .map(q => {
                const questions = q.questions.filter(
                  q => hasTag(q) && isIncorrect(q)
                );
                const correctCount = questions.reduce(
                  (num, q) =>
                    q.selectedOptionIndex !== null &&
                    q.options[q.selectedOptionIndex].correctOption
                      ? num + 1
                      : num,
                  0
                );
                return Object.assign(q, { questions, correctCount });
              })
              .filter(hasQuestions)
          : [];
      }
      return history[filterKey].filter(q => hasTag(q) && isIncorrect(q));
    }
    return [];
  }

  buildPageNav(listData) {
    const { paginationIndex, currentPageRange } = this.state;
    const pageCount = Math.ceil(listData.length / pageSize);
    if (currentPageRange.length === 0) {
      this.setState({
        currentPageRange: _.range(
          pageCount < pageDisplayCount ? pageCount : pageDisplayCount
        ).map(n => n + 1)
      });
    }

    return (
      <div className="history-page-nav">
        {currentPageRange[0] > 1 ? (
          <p
            className="his-nav-prev"
            onClick={() => {
              const newMin = currentPageRange[0] - pageDisplayCount;
              const newRange = _.range(pageDisplayCount).map(n => newMin + n);
              this.setState({
                currentPageRange: newRange,
                paginationIndex: newRange[0] - 1
              });
            }}
          >
            PREV
          </p>
        ) : null}
        {this.state.currentPageRange.filter(n => n <= pageCount).map(i => (
          <p
            className="his-nav-item"
            style={i === paginationIndex + 1 ? { color: 'black' } : {}}
            key={i}
            onClick={() => this.setState({ paginationIndex: i - 1 })}
          >
            {i}
          </p>
        ))}
        {currentPageRange[currentPageRange.length - 1] < pageCount ? (
          <p
            className="his-nav-next"
            onClick={() => {
              const newMin = currentPageRange[0] + pageDisplayCount;
              const newRange = _.range(pageDisplayCount)
                .map(n => newMin + n)
                .filter(n => n <= pageCount);
              this.setState({
                currentPageRange: newRange,
                paginationIndex: newRange[0] - 1
              });
            }}
          >
            NEXT
          </p>
        ) : null}
      </div>
    );
  }

  reviewQuizOrSelection(quizIndex = null, currentQuestionIndex = 0) {
    const { history, setCurrent, initViewOnlyQuiz } = this.props;
    const { filterKey, tagFilter, incorrectFilter } = this.state;

    const hasTag = q => q.organSystemTagId === tagFilter;

    const selection =
      quizIndex === null
        ? history[filterKey]
        : this.filterListData()[quizIndex];
    const viewOnlyConfig = {
      currentQuestionIndex,
      viewOnly: filterKey !== 'quizzes',
      review: filterKey === 'quizzes',
      mode: 0
    };

    const reviewData =
      quizIndex === null
        ? Object.assign(viewOnlyConfig, {
            questions: tagFilter === null ? selection : selection.filter(hasTag)
          })
        : Object.assign(selection, viewOnlyConfig);
    Object.assign(
      reviewData,
      incorrectFilter
        ? {
            questions: reviewData.questions.filter(
              q =>
                q.selectedOptionIndex !== null &&
                !q.options[q.selectedOptionIndex].correctOption
            )
          }
        : {}
    );

    setCurrent().then(() => {
      initViewOnlyQuiz(reviewData).then(() => {
        this.setState({ reviewFlag: true, quizIndex, reviewData });
        window.scrollTo(0, 0);
      });
    });
  }

  quizIncorrect() {
    const questionMap = {};
    const maxCount = 50;

    this.props.history.quizzes.reverse().forEach(q => {
      const count = Object.keys(questionMap).length;
      count < maxCount
        ? q.questions.reverse().forEach((q, i) => {
            const count = Object.keys(questionMap).length;
            count < maxCount &&
            questionMap[q.id] === undefined &&
            q.lastAttemptIncorrect
              ? (questionMap[q.id] = true)
              : null;
          })
        : null;
    });

    const questions = Object.keys(questionMap);
    this.props.changeState('init', { questions });
  }

  quizBookmarks() {
    const questions = this.props.history.bookmarks.map(q => q.id);
    this.props.changeState('init', { questions });
  }

  render() {
    const ctaGroup = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-icons-3@3x.png`)
      : null;
    const { tags, history, isDirty } = this.props;
    const {
      paginationIndex,
      filterKey,
      reviewFlag,
      tagFilter,
      quizIndex,
      incorrectFilter,
      reviewData
    } = this.state;
    const listData = this.filterListData();
    const paginatedData = listData.slice(
      pageSize * paginationIndex,
      pageSize * (paginationIndex + 1)
    );
    const resultCount = listData ? filterQuizzesWithAnsweredQuestions(listData).length : null;
    const isFilteredByQuiz = filterKey === 'quizzes';
    const tag = tags.length ? tags.filter(t => t.id === tagFilter)[0] : {};
    const filteredCountData = tagFilter
      ? isFilteredByQuiz
        ? listData.reduce(
            (stats, quiz) =>
              Object.assign(stats, {
                correct:
                  stats.correct +
                  quiz.questions.reduce(
                    (correctCount, q) =>
                      q.selectedOptionIndex !== null &&
                      q.options[q.selectedOptionIndex].correctOption
                        ? correctCount + 1
                        : correctCount,
                    0
                  ),
                total:
                  stats.total +
                  quiz.questions.filter(q => q.selectedOptionIndex !== null)
                    .length
              }),
            { correct: 0, total: 0 }
          )
        : {
            correct: listData.reduce(
              (correctCount, q) =>
                q.selectedOptionIndex !== null &&
                q.options[q.selectedOptionIndex].correctOption
                  ? correctCount + 1
                  : correctCount,
              0
            ),
            total: listData.filter(q => q.selectedOptionIndex !== null).length
          }
      : null;
    const percent = filteredCountData
      ? Math.round(filteredCountData.correct / filteredCountData.total * 100)
      : 0;
    const quiz = history.quizzes ? history.quizzes[quizIndex] : null;

    return (
      <div
        className={`${isDirty ? 'loading-wrapper' : 'history-content'}`}
        style={{ minHeight }}
      >
        {isDirty ? (
          <LoadingSpinner />
        ) : reviewFlag ? (
          <div>
            <div
              className="history-back"
              onClick={() => this.setState({ reviewFlag: false })}
            >
              <img src={ArrowLeft} />
              <p>QUIZ HISTORY</p>
            </div>
            <Title className="history-review-title" title="QUIZ REVIEW" />
            {isFilteredByQuiz ? (
              <div className="quiz-review-header">
                <p>
                  {new Date(quiz.createdAt).toLocaleDateString('en-us', {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric'
                  })}
                </p>
                <p>{quiz.questions.length} Questions</p>
                <p>{quiz.mode === 0 ? 'Study' : 'Test'} Mode</p>
                <p>
                  Score:{' '}
                  <span
                    style={{
                      fontWeight: 'bold',
                      color: HELPERS.GET_PERCENT_COLOR(
                        Math.round(
                          100 * (quiz.correctCount / quiz.questions.length)
                        )
                      )
                    }}
                  >
                    {Math.round(
                      100 * (quiz.correctCount / quiz.questions.length)
                    )}%
                  </span>
                </p>
              </div>
            ) : (
              <div className="selection-review-header">
                <p>You are reviewing:</p>
                <p className="selection-labels">
                  {filterKey === 'notes' ? 'Notes' : 'Bookmarks'}
                  {incorrectFilter ? ', Incorrect Only' : ''}
                  {tagFilter ? `, ${tag.title}` : ''}
                  {` (${reviewData.questions.length})`}
                </p>
              </div>
            )}
            <Quiz />
          </div>
        ) : isMobile ? (
          renderMobile.call(this)
        ) : (
          <div>
            <Title title="QUIZ HISTORY" />
            <div className="history-body">
              <div className="history-sidebar">
                <div className="history-button-wrapper">
                  <QbankButton
                    style={buttonStyle}
                    onClick={() => this.quizIncorrect()}
                    disabled={history.quizzes.reduce(
                      (dis, q) =>
                        dis &&
                        q.questions.reduce(
                          (dis, q) =>
                            dis &&
                            (q.options[q.selectedOptionIndex] === null ||
                              q.options[q.selectedOptionIndex] === undefined ||
                              q.options[q.selectedOptionIndex].correctOption),
                          true
                        ),
                      true
                    )}
                    label="QUIZ INCORRECT"
                  />
                </div>
                <div className="history-button-wrapper">
                  <QbankButton
                    style={buttonStyle}
                    onClick={() => this.quizBookmarks()}
                    className={
                      this.props.history.bookmarks &&
                      !this.props.history.bookmarks.length
                        ? ''
                        : 'secondary'
                    }
                    disabled={
                      this.props.history.bookmarks &&
                      !this.props.history.bookmarks.length
                    }
                    label="QUIZ BOOKMARKS"
                  />
                </div>
                <p className="history-sb-title">SHOW</p>
                {filters.map((label, i) =>
                  this.buildHistoryCheckInput(label, i)
                )}
                <QbankBreak />
                <Toggle
                  className="history-toggle"
                  toggled={incorrectFilter}
                  onToggle={() =>
                    this.setState(currState => ({
                      incorrectFilter: !currState.incorrectFilter
                    }))
                  }
                  label="Show Incorrect Only"
                  labelPosition="right"
                  trackSwitchedStyle={{ backgroundColor: '#94C057' }}
                  thumbSwitchedStyle={{
                    backgroundColor: 'white',
                    border: '1px solid #94C057'
                  }}
                />
                <p className="history-sb-title">ORGAN SYSTEM</p>
                <div className="history-tags-wrapper">
                  {this.buildHistoryCheckInput('ALL', 'ALL', true)}
                  {tags.map((tag, i) =>
                    this.buildHistoryCheckInput(tag.title, i, true)
                  )}
                </div>
              </div>
              <div className="history-main">
                <div className="history-info-header">
                  <p className="history-results">{`${resultCount} ${
                    isFilteredByQuiz ? 'Quiz' : 'Result'
                  }${
                    resultCount !== 1 ? (isFilteredByQuiz ? 'zes' : 's') : ''
                  }`}</p>
                  {!isFilteredByQuiz && history[filterKey].length ? (
                    <p
                      className="review-cta"
                      onClick={() => this.reviewQuizOrSelection()}
                    >
                      REVIEW SELECTION
                    </p>
                  ) : null}
                </div>
                <QbankBreak />
                {tagFilter ? (
                  <div className="history-tag-header">
                    <div>
                      <img src={tag ? tag.imageUrl : ''} />
                      <p>{tag.title}</p>
                    </div>
                    <div>
                      <Line
                        percent={percent}
                        className="history-organ-bar"
                        strokeWidth="8"
                        trailWidth="8"
                        strokeLinecap="square"
                        strokeColor={
                          isNaN(percent)
                            ? '#D9D9D9'
                            : HELPERS.GET_PERCENT_COLOR(percent)
                        }
                      />
                      <p
                        className="history-tag-header-percent"
                        style={{
                          color: isNaN(percent)
                            ? '#777'
                            : HELPERS.GET_PERCENT_COLOR(percent)
                        }}
                      >
                        {isNaN(percent) ? '--' : percent}%
                      </p>
                      <QbankButton
                        className={`${
                          this.props.isTrial ? '' : 'secondary'
                        } button-hover'${
                          isSmallMobile
                            ? ' small-mobile-dash-button'
                            : isMobile ? ' mobile-dash-button' : ''
                        }`}
                        label="QUIZ TOPIC"
                        disabled={this.props.isTrial}
                        style={{
                          width: '140px',
                          height: '35px',
                          fontSize: '13px'
                        }}
                        onClick={() => {
                          this.props.changeState('init', {
                            fromDash: [tag.id]
                          });
                        }}
                      />
                    </div>
                  </div>
                ) : null}
                {history.quizzes.length && history[filterKey].length ? (
                  <div className="history-list">
                    {paginatedData.map(
                      (d, i) =>
                        isFilteredByQuiz
                          ? d.questions.reduce(
                              (count, q) => (q.answered ? count + 1 : count),
                              0
                            )
                            ? this.buildQuizCollapsible(
                                d,
                                paginationIndex * pageSize + i
                              )
                            : null
                          : this.buildListItem(
                              d,
                              paginationIndex * pageSize + i
                            )
                    )}
                  </div>
                ) : (
                  <div className="history-no-data prompt-container card">
                    <img alt="" src={ctaGroup} />
                    <QbankButton
                      className="dash-start-new"
                      label={
                        this.props.isTrial
                          ? 'START FREE TRIAL'
                          : 'START NEW QUIZ'
                      }
                      style={styles.quizButton}
                      onClick={() =>
                        this.props.changeState('init', { skip: true })
                      }
                    />
                  </div>
                )}
                {listData.length > pageSize
                  ? this.buildPageNav(listData)
                  : null}
              </div>
            </div>
          </div>
        )}
      </div>
    );

    function renderMobile() {
      return (
        <div className="mobile-history-wrapper">
          {this.state.mobileFilter ? (
            <div>
              <div
                className="mobile-history-filter"
                style={{
                  height: window.innerHeight - 105
                }}
              >
                <Title title="FILTER QUESTIONS" />
                <div className="history-sidebar">
                  <p className="history-sb-title">SHOW</p>
                  {filters.map((label, i) =>
                    this.buildHistoryCheckInput(label, i)
                  )}
                  <QbankBreak />
                  <Toggle
                    className="history-toggle"
                    toggled={incorrectFilter}
                    onToggle={() =>
                      this.setState(currState => ({
                        incorrectFilter: !currState.incorrectFilter
                      }))
                    }
                    label="Show Incorrect Only"
                    labelPosition="right"
                    trackSwitchedStyle={{ backgroundColor: '#94C057' }}
                    thumbSwitchedStyle={{
                      backgroundColor: 'white',
                      border: '1px solid #94C057'
                    }}
                  />
                  <p className="history-sb-title">ORGAN SYSTEM</p>
                  <div className="history-tags-wrapper">
                    {this.buildHistoryCheckInput('ALL', 'ALL', true)}
                    {tags.map((tag, i) =>
                      this.buildHistoryCheckInput(tag.title, i, true)
                    )}
                  </div>
                </div>
              </div>
              <div className="history-mobile-button">
                <div className="history-button-wrapper">
                  <QbankButton
                    style={styles.quizButton}
                    onClick={() =>
                      this.setState({ mobileFilter: !this.state.mobileFilter })
                    }
                    label="APPLY"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div
                className="mobile-history"
                style={{
                  height: window.innerHeight - 105
                }}
              >
                <div className="hist-mob-title-row">
                  <Title title="QUIZ HISTORY" />
                  <img
                    src={tagFilter ? FilterActiveIcon : FilterIcon}
                    onClick={() =>
                      this.setState({ mobileFilter: !this.state.mobileFilter })
                    }
                  />
                </div>
                <div className="history-body">
                  <div className="history-main">
                    <div className="history-info-header">
                      <p className="history-results">{`${resultCount} ${
                        isFilteredByQuiz ? 'Quiz' : 'Result'
                      }${
                        resultCount !== 1
                          ? isFilteredByQuiz ? 'zes' : 's'
                          : ''
                      }`}</p>
                      {!isFilteredByQuiz && history[filterKey].length ? (
                        <p
                          className="review-cta"
                          onClick={() => this.reviewQuizOrSelection()}
                        >
                          REVIEW SELECTION
                        </p>
                      ) : null}
                    </div>
                    <QbankBreak />
                    {tagFilter ? (
                      <div className="history-tag-header">
                        <div>
                          <img src={tag ? tag.imageUrl : ''} />
                          <p>{tag.title}</p>
                        </div>
                        <div>
                          <Line
                            percent={percent}
                            className="history-organ-bar"
                            strokeWidth="8"
                            trailWidth="8"
                            strokeLinecap="square"
                            strokeColor={
                              isNaN(percent)
                                ? '#D9D9D9'
                                : HELPERS.GET_PERCENT_COLOR(percent)
                            }
                          />
                          <p
                            className="history-tag-header-percent"
                            style={{
                              color: isNaN(percent)
                                ? '#777'
                                : HELPERS.GET_PERCENT_COLOR(percent)
                            }}
                          >
                            {isNaN(percent) ? '--' : percent}%
                          </p>
                          <QbankButton
                            className={`${
                              this.props.isTrial ? '' : 'secondary'
                            } button-hover'${
                              isSmallMobile
                                ? ' small-mobile-dash-button'
                                : isMobile ? ' mobile-dash-button' : ''
                            }`}
                            label="QUIZ TOPIC"
                            disabled={this.props.isTrial}
                            style={{
                              width: '140px',
                              height: '35px',
                              fontSize: '13px'
                            }}
                            onClick={() => {
                              this.props.changeState('init', {
                                fromDash: [tag.id]
                              });
                            }}
                          />
                        </div>
                      </div>
                    ) : null}
                    {history.quizzes.length && history[filterKey].length ? (
                      <div className="history-list">
                        {paginatedData.map(
                          (d, i) =>
                            isFilteredByQuiz
                              ? this.buildQuizCollapsible(
                                  d,
                                  paginationIndex * pageSize + i
                                )
                              : this.buildListItem(
                                  d,
                                  paginationIndex * pageSize + i
                                )
                        )}
                      </div>
                    ) : (
                      <div className="history-no-data prompt-container card">
                        <img alt="" src={ctaGroup} />
                        <QbankButton
                          className="dash-start-new"
                          label={
                            this.props.isTrial
                              ? 'START FREE TRIAL'
                              : 'START NEW QUIZ'
                          }
                          style={styles.quizButton}
                          onClick={() =>
                            this.props.changeState('init', { skip: true })
                          }
                        />
                      </div>
                    )}
                    {listData.length > pageSize
                      ? this.buildPageNav(listData)
                      : null}
                  </div>
                </div>
              </div>
              <div className="history-mobile-buttons">
                <div className="history-button-wrapper">
                  <QbankButton
                    style={styles.quizButton}
                    onClick={() => this.quizIncorrect()}
                    disabled={history.quizzes.reduce(
                      (dis, q) =>
                        dis &&
                        q.questions.reduce(
                          (dis, q) =>
                            dis &&
                            (q.options[q.selectedOptionIndex] === null ||
                              q.options[q.selectedOptionIndex] === undefined ||
                              q.options[q.selectedOptionIndex].correctOption),
                          true
                        ),
                      true
                    )}
                    label="QUIZ INCORRECT"
                  />
                </div>
                <div className="history-button-wrapper">
                  <QbankButton
                    style={styles.quizButton}
                    onClick={() => this.quizBookmarks()}
                    className={
                      this.props.history.bookmarks &&
                      !this.props.history.bookmarks.length
                        ? ''
                        : 'secondary'
                    }
                    disabled={
                      this.props.history.bookmarks &&
                      !this.props.history.bookmarks.length
                    }
                    label="QUIZ BOOKMARKS"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  //TODO replace with proper action if ever back along w/fetchTags.js
  state.tags =
    state.tags && state.tags.length ? state.tags : state.app.backupTags;

  return {
    history: state.filtered,
    isDirty:
      !state.filtered || !state.filtered.quizzes || state.filtered.isDirty,
    tags: state.tags,
    product: state.app.product
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { fetchHistory, setCurrent, initViewOnlyQuiz, changeState },
    dispatch
  );
}

// Given an array of quizzes, return the ones which have at least one question answered.
// Given an array of non-quizzes, returns "count"
// NOTE: HACK ALERT - I think this whole codebase should be rewritten at somepoint,
// so rather than refactoring anything & running the risk of wasting thime, I'm
// just going to make the thing work right now.
function filterQuizzesWithAnsweredQuestions(collection) {
  return collection.filter(item => {
    if (!item.questions) {
      return true;
    } else {
      return item.questions.reduce(
        (count, q) => (q.answered ? count + 1 : count),
        0
      ) > 0;
    }
  });
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizHistory);



// WEBPACK FOOTER //
// ./src/containers/QuizHistory.js